import React, { Fragment } from 'react';
import { Table } from 'reactstrap';
import { Toolkit } from '../../../../services/types/Toolkit';
import { Operation } from '../../../../services/types/Operation';
import ToolkitVersion from './ToolkitVersion';
import { CheckValue } from '../../../../services/types/Misc';

interface Props {
  operation: Operation;
  toolkits: Toolkit[];
  availableLanguages: { toolkitId: number; languages: CheckValue[] }[];
  handleChange: (id: string, value: boolean, toolkitId: number) => void;
  handleDownloadClick: (toolkitId: number) => void;
  handleDownloadClickEzshare: (ezShareCode: string) => void;
  className?: string;
}

const VersionTable = (props: Props) => {
  const {
    operation,
    toolkits,
    availableLanguages,
    handleChange,
    handleDownloadClick,
    handleDownloadClickEzshare,
    className,
  } = props;

  const renderRows = toolkits.map((toolkit) => {
    const toolkitLanguages = availableLanguages.find((x) => x.toolkitId === toolkit.id);
    return (
      <Fragment key={toolkit.id}>
        {toolkitLanguages && (
          <ToolkitVersion
            key={`tv_${toolkit.version}`}
            toolkit={toolkit}
            operation={operation}
            pdfOptions={toolkitLanguages.languages}
            handleChange={(id, value) => handleChange(id, value, toolkit.id)}
            handleDownloadClick={handleDownloadClick}
            handleDownloadClickEzshare={handleDownloadClickEzshare}
          />
        )}
      </Fragment>
    );
  });

  return (
    <div className={className}>
      <hr />
      <div className="table-wrapper sticky-section w-100">
        <Table className="toolkit_table">
          <thead>
            <tr>
              <th>Toolkit Form</th>
              <th>ESIC</th>
              <th>DCCRC</th>
              <th>Created By</th>
              <th>Toolkit Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{renderRows}</tbody>
        </Table>
      </div>
    </div>
  );
};

export default VersionTable;
